import packageInfo from '../../package.json';

export const environment = {
    production: false,
    name: 'dev',
    reportErrors: false,
    api: {
        key: '77777772d445c84bb8bd8910c4f6b29e0698b421753e652151349c9498797075',
        baseUrl: 'https://dev-api-em3.cufi.org/v2',
    },
    smartyStreetSettings: {
        streetAddressApiUrl: 'https://us-street.api.smartystreets.com',
        autoCompleteApiUrl: 'https://us-autocomplete.api.smartystreets.com',
        clientAuthId: '25022836015240220',
        authId: '67bdf7e6-80d6-054c-adb9-317a6ea10cda',
        authToken: '7XDCfdtnHtIHHtgVGxfU',
    },
    authCookieName: '.IuNYworqKU',
    keycloakAuthority: 'https://accounts.cufi.org/realms/em3-dev',
    appVersion: packageInfo.version,
    sentry: {
        dsn: 'https://96fe8fa839ce6815b13e3a29cee1589e@o4511496135573504.ingest.us.sentry.io/4511496148549632',
        environment: 'development',
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
    },
};
